import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductDatingInternationalForm, ProductDatingInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-product-dating-international-step',
    templateUrl: './product-dating-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodProductDatingInternationalStepComponent extends BaseInternationalStep implements OnInit {
    @Input() productDatingInternationalForm: FormGroup<ProductDatingInternationalFormGroup> | undefined;

    public showFinancialAdjustment = false;
    public showRelatedDocuments = false;

    ngOnInit(): void {
        this.initChangesListener();
    }

    constructor(private store: Store) {
        super();
    }

    public isDefined(control: keyof ProductDatingInternationalForm): boolean {
        return this.productDatingInternationalForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof ProductDatingInternationalForm): boolean {
        return this.productDatingInternationalForm?.controls[control].value === true;
    }

    public isFalse(control: keyof ProductDatingInternationalForm): boolean {
        return this.productDatingInternationalForm?.controls[control].value === false;
    }

    public evaluate(): void {
        const relatedDocuments = this.productDatingInternationalForm?.controls.relatedDocuments.value || [];

        if (this.isTrue('declinedWithin24Hours')) {
            this.showRelatedDocuments = true;
            this.showFinancialAdjustment = true;
            return;
        }

        if (this.isTrue('batchExpiryMeetsMinShipPolicy')) {
            this.showRelatedDocuments = true;
            this.showFinancialAdjustment = false;
            return;
        }

        if (this.isFalse('batchExpiryMeetsMinShipPolicy') || relatedDocuments.length > 0) {
            this.showRelatedDocuments = true;
            this.showFinancialAdjustment = true;
            return;
        }
    }

    public handleConfirm() {
        if (this.productDatingInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.productDatingInternationalForm?.valid ?? false;
    }

    private initChangesListener(): void {
        this.productDatingInternationalForm?.valueChanges
            .pipe(
                tap(() => {
                    this.evaluate();
                })
            )
            .subscribe();
    }
}
